/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Dialog, Tooltip, Typography } from "@mui/material";
import { PropsWithChildren, useState } from "react";
import InfoIcon from '@mui/icons-material/Info';
import SuccessErrorModal, { MessageType } from "../modals/SuccessErrorModal";
import modalStyle from '../../styles/SuccessError.module.css';

interface Props {
  sectionHeader?: string
  subSectionHeader?: string
  infoData?:string
  styles?:any
  title?:string
}
export default function FormSection({ sectionHeader, subSectionHeader,infoData,title, children, styles, ...props }: PropsWithChildren<Props>) {
 
  const [open, setOpen] = useState(false);

  const handleClose =()=>{
    setOpen(false)
  }
 
  return (
    <div>
     <SuccessErrorModal
        type={MessageType.dialog}
        open={open}
        handleClose={handleClose}
        style={modalStyle}
        title={sectionHeader}
        message={infoData} />

      {sectionHeader && <>
      <div className="sectionHeaderParent">
        <div className={!!styles ?  styles.sectionHeader : 'sectionHeader'}>
          {sectionHeader}
         
        </div> {infoData && <InfoIcon className='infoIcon' onClick={()=>{setOpen(true)}}/>}
        </div>
        {subSectionHeader && <>
        <br/>
        <Typography
          variant="body1" display="inline" paragraph>
          {subSectionHeader}
        </Typography>
      </>}
      </>}
      {children}
      </div>
  )
}